import { Component, inject, Input } from '@angular/core';
import { Job } from '../../../model/job.model';
import { UserService } from '../../../services/user.service';
import { MessagingService } from '../../../components/messaging/messaging.service';
import { MatButton } from '@angular/material/button';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { JobReportInvoiceFilterPipe } from './job-report-invoice-filter.pipe';

@Component({
  selector: 'app-job-reports',
  template: `
    <button matButton="elevated" class="white-button" [matMenuTriggerFor]="reportsMenu">
      <mat-icon class="size-18! text-18! mr-5">picture_as_pdf</mat-icon>
      <span class="subtitle-1">REPORTS</span>
    </button>
    <mat-menu #reportsMenu="matMenu" class="new-actions-kebab-menu">
      <div class="menu-grouping">
        <button (click)="openPdfReport('repairer')" mat-menu-item>
          <span>Repairer Report</span>
        </button>

        @if (job?.authority) {
          <button (click)="openPdfReport('authority')" mat-menu-item>
            <span>Authority Report</span>
          </button>
        }

        @if ((job?.enableToSelfAuthorized || job?.preAuthority) && !job?.authority) {
          <button (click)="openPdfReport('pre_authorized')" mat-menu-item>
            <span>Pre Authority Report</span>
          </button>
        }

        @for (invoice of submittedItems | jobReportInvoiceFilter; track invoice) {
          <button (click)="openInvoicePdfReport(invoice.id)" mat-menu-item>
            <span>Invoice {{ invoice.invoiceNumber }} Report</span>
          </button>
        }
      </div>
    </mat-menu>
  `,
  imports: [MatButton, MatMenuTrigger, MatIcon, MatMenu, MatMenuItem, JobReportInvoiceFilterPipe]
})
export class JobReportsComponent {
  @Input() job: Job;
  @Input() submittedItems: any[];

  #userService = inject(UserService);
  #message = inject(MessagingService);

  openPdfReport(reportType: string): void {
    this.#userService.getJobReport(`jobs/${this.job.jobId}/reports/${reportType}`).subscribe({
      error: () => this.#message.error('Could not retrieve the report.')
    });
  }

  openInvoicePdfReport(invoiceId: string | number): void {
    this.#userService.getJobReport(`jobs/${this.job.jobId}/reports/invoice/${invoiceId}`).subscribe({
      error: () => this.#message.error('Could not retrieve the invoice report.')
    });
  }
}
